import type { AiLeagueTabConfig, AiModelId } from './aiLeagueTypes';

export const AI_LEAGUE_TABS: AiLeagueTabConfig[] = [
  { id: 'ai-league', label: 'AI League' },
  { id: 'chatgpt', label: 'ChatGPT' },
  { id: 'claude', label: 'Claude' },
  { id: 'gemini', label: 'Gemini' },
  { id: 'grok', label: 'Grok' },
  { id: 'deepseek', label: 'DeepSeek' },
  { id: 'fable5', label: 'Fable 5' },
  { id: 'methodology', label: 'Methodology' },
];

export const AI_MODEL_IDS: AiModelId[] = ['chatgpt', 'claude', 'gemini', 'grok', 'deepseek', 'fable5'];

/** Valid-list models eligible for admin swap configuration (ChatGPT excluded). */
export const AI_SWAPPABLE_MODEL_IDS: AiModelId[] = AI_MODEL_IDS.filter((id) => id !== 'chatgpt');

export function getAiModelTabIndex(modelId: AiModelId): number {
  return AI_LEAGUE_TABS.findIndex((tab) => tab.id === modelId);
}

export function getMethodologyTabIndex(): number {
  return AI_LEAGUE_TABS.findIndex((tab) => tab.id === 'methodology');
}
